export default __webpack_public_path__ + "static/estalia-da4e54dc89e8fcc6f10cf0d9131f3a2a.webp";